import * as types from './mutation-types';
import { requestInfo } from '@/utils/utils';
import { queryPatientList, batchGetPatientPortraitTag } from '@/services/user/index.ts';
export const asyncSetPatientList = async ({ commit, state }, query) => {
  commit(types.SET_LOADING, true);
  const source = Object.prototype.hasOwnProperty.call(query, 'source') ? query.source : 'patient';
  const rsp = await queryPatientList({
    ...query,
    source,
  });
  const { totalCounts, patientList } = rsp;
  patientList.forEach((item) => {
    item.isShowGroupList = false;
  });
  // 清空已选患者
  // commit(types.SET_SELECT_LIST, []); 为了列表和表头表现一致以及体现reserve-selection设计意图，禁止在每次搜索患者的时候清空已选患者列表
  if (source === 'patient') {
    commit(types.SET_PATIENT_LIST, patientList);
    commit(types.SET_PATIENT_COUNT, totalCounts);
  }
  if (rsp) {
    commit(types.SET_LOADING, false);
  }

  // 如果列配置中勾选了标签字段，异步请求标签信息（不阻塞主表格渲染）
  if (source === 'patient' && state.isShowTagInfo && patientList.length) {
    commit(types.SET_TAG_INFO_LOADING, true);
    try {
      const patientIds = patientList.map(p => p.patientId);
      const tagData = await batchGetPatientPortraitTag(patientIds);
      // tagData 结构: { patientId1: { height, weight, bmi, diseaseInfo, ... }, patientId2: { ... } }
      const merged = state.patientList.map(p => ({
        ...p,
        ...(tagData[p.patientId] || {}),
      }));
      commit(types.SET_PATIENT_LIST, merged);
    } catch (e) {
      // 标签信息加载失败不影响主列表
      console.error('batchGetPatientPortraitTag error:', e);
    } finally {
      commit(types.SET_TAG_INFO_LOADING, false);
    }
  }
};

export const asyncGetLocationList = async ({ commit, state }) => {
  if (state.provinceList.length) return;
  const res = await requestInfo({
    api: 'GetLocationList',
  });
  commit(types.SET_LOCATION_INFO, res);
};
